import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";

import { getWorkTreeById } from "@/actions/work-tree";
import { queryKeys } from "@/constants/query";
import { isValidOrgId } from "@/lib/utils";

export const useWorkTree = () => {
  const { orgId, projectId } = useParams();
  const { data, isLoading, error, isError } = useQuery({
    queryKey: queryKeys.getWorkTreeById(projectId as string),
    queryFn: () => getWorkTreeById(projectId as string),
    enabled: isValidOrgId(orgId as string | undefined) && !!projectId,
  });

  return {
    data,
    isLoading,
    error,
    isError,
  };
};
